<div class="audio-modes-menu flex flex-column">
  <div class="audio-modes-container m-b-8 p-8">
    <app-advanced-presentation-settings
      [allowGroupConversations]="groupConversationsV1 ? false : !!settingsFormState?.allowGroupConversations"
      [defaultFullScreen]="!!settingsFormState?.defaultFullScreen"
      [requireFullScreen]="!!settingsFormState?.requireFullScreen"
      [interactionMode]="settingsFormState?.interactionMode"
      (changeEvent)="handleAdvancedSettingChange($event)"
    ></app-advanced-presentation-settings>
  </div>
  <div class="footer flex justify-center">
    <button mat-button class="save-btn m-t-16" [disabled]="!dirty" (click)="submit()">Save</button>
  </div>
</div>
